import styled, { css } from "styled-components";

import Props from "./props";

const FabGroup = styled.div<Props>`
    position: fixed;
    width: 3.5rem;
    text-align: center;
    padding-bottom: 3.5rem;
    bottom: 1rem;
    right: 1rem;
    z-index: 1;
    ${({ active }) =>
        active
            ? css`
                  pointer-events: auto;
              `
            : css`
                  pointer-events: none;
              `}
    @media print {
        display: none;
    }
`;

export default FabGroup;
